// GlobalStateContext.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reference: "",
  referenceClient: "",
  document: "",
  status: "",
  startDate: "",
  endDate: "",
  lastStatusStartDate: "",
  lastStatusEndDate: "",
  nameUbication: "",
  isoCode2: "",
  daneCode: "",
  configCode: "",
  allyType: "",

  referenceProyT: "",
  documentProyT: "",
  statusProyT: "",
  startDateProyT: "",
  endDateProyT: "",
  lastStatusStartDateProyT: "",
  lastStatusEndDateProyT: "",

  referenceVerification: "",
  statusVerification : "",
  certificateType: "",
  startDateVerification: "",
  endDateVerification: "",
  lastStatusStartDateVerification: "",
  lastStatusEndDateVerification: "",

  emailOnPhone: "",
  statusElectronic: "",
  lastStatusStartDateElectronic: "",
  lastStatusEndDateElectronic: "",

  emailOtherServices: "",
  lastStatusStartDateOtherServices: "",
  lastStatusEndDateOtherServices: "",
  statusOtherServices: "",

  referenceLogistic : "",
  statusLogistic : "",
  startDateLogistic : "",
  endDateLogistic : "",

  referenceAgreements: "",
  startDateAgreements: "",
  endDateAgreements: "",
  disabled: false,

  statusProcess: "",

  subscriberByAggreement: "",
  referenceByAggreement: "",
};

export const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setReferenceProyTFilter: (state, action) => {
      state.referenceProyT = action.payload;
    },
    setDocumentProyTFilter: (state, action) => {
      state.documentProyT = action.payload;
    },
    setStatusProyTFilter: (state, action) => {
      state.statusProyT = action.payload;
    },
    setStartDateProyTFilter: (state, action) => {
      state.startDateProyT = action.payload;
    },
    setEndDateProyTFilter: (state, action) => {
      state.endDateProyT = action.payload;
    },
    setLastStatusStartDateProyTFilter: (state, action) => {
      state.lastStatusStartDateProyT = action.payload;
    },
    setLastStatusEndDateProyTFilter: (state, action) => {
      state.lastStatusEndDateProyT = action.payload;
    },

    setReferenceVerification: (state, action) => {
      state.referenceVerification = action.payload;
    },
    setStatusVerification: (state, action) => {
      state.statusVerification = action.payload;
    },
    setCertificateType: (state,action)=> {
      state.certificateType = action.payload;
    },
    setStartDateVerification: (state, action) => {
      state.startDateVerification = action.payload;
    },
    setEndDateVerification: (state, action) => {
      state.endDateVerification = action.payload;
    },
    setLastStatusStartDateVerification: (state, action) => {
      state.lastStatusStartDateVerification = action.payload;
    },
    setLastStatusEndDateVerification: (state, action) => {
      state.lastStatusEndDateVerification = action.payload;
    },

    setEmailOnPhone: (state, action) => {
      state.emailOnPhone = action.payload;
    },
    setStatusElectronic: (state, action) => {
      state.statusElectronic = action.payload;
    },
    setLastStatusStartDateElectronic: (state, action) => {
      state.lastStatusStartDateElectronic = action.payload;
    },
    setLastStatusEndDateElectronic: (state, action) => {  
      state.lastStatusEndDateElectronic = action.payload;
    },

    setEmailOtherServices: (state, action) => {
      state.emailOtherServices = action.payload;
    },
    setLastStatusStartDateOtherServices: (state, action) => {
      state.lastStatusStartDateOtherServices = action.payload;
    },
    setLastStatusEndDateOtherServices: (state, action) => {
      state.lastStatusEndDateOtherServices = action.payload;
    },
    setStatusOtherServices : (state, action) => {
      state.statusOtherServices = action.payload;
    },
    setStatusProcess : (state, action) => {
      state.statusProcess = action.payload;
    },
    setReferenceClientFilter: (state, action) => {
      state.referenceClient = action.payload;
    },
    setReferenceFilter: (state, action) => {
      state.reference = action.payload;
    },
    setDocumentFilter: (state, action) => {
      state.document = action.payload;
    },
    setStatusFilter: (state, action) => {
      state.status = action.payload;
    },
    setStartDateFilter: (state, action) => {
      state.startDate = action.payload;
    },
    setEndDateFilter: (state, action) => {
      state.endDate = action.payload;
    },
    setLastStatusStartDateFilter: (state, action) => {
      state.lastStatusStartDate = action.payload;
    },
    setLastStatusEndDateFilter: (state, action) => {
      state.lastStatusEndDate = action.payload;
    },
    setNameUbication: (state, action) => {
      state.nameUbication = action.payload;
    },
    setIsoCode2: (state, action) => {
      state.isoCode2 = action.payload;
    },
    setDaneCode: (state, action) => {
      state.daneCode = action.payload;
    },
    setConfigCode: (state, action) => {
      state.configCode = action.payload;
    },
    setAllyType: (state, action) => {
      state.allyType = action.payload;
    },
    setReferenceLogistic: (state, action) => {
      state.referenceLogistic = action.payload;
    },
    setStatusLogistic: (state, action) => {
      state.statusLogistic = action.payload;
    },
    setStartDateLogistic: (state, action) => {
      state.startDateLogistic = action.payload;
    },
    setEndDateLogistic: (state, action) => {
      state.endDateLogistic = action.payload;
    },
    setReferenceAgreements: (state, action) => {
      state.referenceAgreements = action.payload.toUpperCase();
    },
    setStartDateAgreements: (state, action) => {
      state.startDateAgreements = action.payload;
    },
    setEndDateAgreements: (state, action) => {
      state.endDateAgreements = action.payload;
    },
    setDisabled: (state,action)=> {
      state.disabled = action.payload;
    },
    setReferenceByAggreement: (state, action) => {
      state.referenceByAggreement = action.payload;
    },
    setSubscriberByAggreement: (state, action) => {
      state.subscriberByAggreement = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setReferenceProyTFilter,
  setDocumentProyTFilter,
  setStatusProyTFilter,
  setStartDateProyTFilter,
  setEndDateProyTFilter,
  setLastStatusStartDateProyTFilter,
  setLastStatusEndDateProyTFilter,

  setReferenceVerification,
  setStatusVerification,
  setCertificateType,
  setStartDateVerification,
  setEndDateVerification,
  setLastStatusStartDateVerification,
  setLastStatusEndDateVerification,

  setEmailOnPhone,
  setStatusElectronic,
  setLastStatusStartDateElectronic,
  setLastStatusEndDateElectronic,

  setEmailOtherServices,
  setLastStatusStartDateOtherServices,
  setLastStatusEndDateOtherServices,
  setStatusOtherServices,
  setStatusProcess,
  
  setReferenceClientFilter,
  setReferenceFilter,
  setDocumentFilter,
  setStatusFilter,
  setStartDateFilter,
  setEndDateFilter,
  setLastStatusStartDateFilter,
  setLastStatusEndDateFilter,
  setDisabled,
  setNameUbication,
  setIsoCode2,
  setDaneCode,
  setConfigCode,
  setAllyType,

  setReferenceLogistic,
  setStatusLogistic,
  setStartDateLogistic,
  setEndDateLogistic,

  setReferenceByAggreement,
  setSubscriberByAggreement,

  setReferenceAgreements,
  setStartDateAgreements,
  setEndDateAgreements,
  reset,
} = filterSlice.actions;
export default filterSlice.reducer;
export const selectInitialState = initialState;
